var _path, _path2, _rect, _rect2, _circle, _circle2, _path3, _path4, _path5, _path6, _path7, _path8, _circle3, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.5 14H27.5C26.9477 14 26.5 14.4477 26.5 15V112C26.5 112.552 26.9477 113 27.5 113H100.5C101.052 113 101.5 112.552 101.5 112V15C101.5 14.4477 101.052 14 100.5 14Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98L39.5 104.5",
    stroke: "#EF2C5A",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 81.5984,
    y: 99.2646,
    width: 5.1814,
    height: 11.2325,
    transform: "rotate(-45 81.5984 99.2646)",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 83.4688,
    y: 105.586,
    width: 11.4722,
    height: 23.4888,
    rx: 1,
    transform: "rotate(-45 83.4688 105.586)",
    fill: "#EF2C5A",
    stroke: "black",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.6898,
    cy: 84.6898,
    r: 18.1898,
    stroke: "black",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.686,
    cy: 84.6889,
    r: 13.8589,
    fill: "#EF2C5A",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4959 81.346H66.3546C66.4438 78.781 68.5182 76.9966 71.3285 76.9966C74.2281 76.9966 76.1686 78.7141 76.1686 81.0337C76.1686 82.3943 75.4103 83.4203 74.1835 84.4687L72.8676 85.5393C71.7746 86.4761 71.5293 87.0783 71.7077 88.8404H70.191C69.7003 86.8106 69.7226 85.8069 71.0163 84.6694L72.3546 83.4872C73.2021 82.7289 73.6928 82.1713 73.6928 81.2345C73.6928 79.9631 72.7114 79.004 71.1055 79.004C69.5888 79.004 68.5628 79.9631 68.4959 81.346ZM72.6891 91.6731C72.6891 92.6321 71.9085 93.3459 70.9048 93.3459C69.901 93.3459 69.1204 92.6321 69.1204 91.6731C69.1204 90.6693 69.8787 89.9556 70.9048 89.9556C71.9308 89.9556 72.6891 90.6693 72.6891 91.6731Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 70L35 61",
    stroke: "#EF2C5A",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5 63.5L95 53.5",
    stroke: "#EF2C5A",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 31H83.5",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 37H91.5",
    stroke: "black",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 43H73.5",
    stroke: "black",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 32,
    r: 5,
    stroke: "black",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 47C53.5 43.6863 49.9183 41 45.5 41C41.0817 41 37.5 43.6863 37.5 47",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCustomer);
export default __webpack_public_path__ + "static/media/emptyCustomer.dbfb0c833fb1274d9e0316d667a2bf69.svg";
export { ForwardRef as ReactComponent };